module.exports = "<div class=\"hint\">\n    عند اضافة صور، يجب ان لا يتجاوز عددها عن صورة واحدة\n</div>"